import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import MainSite from './components/MainSite';
import DepartmentPage from './components/DepartmentPage';
import Checkout from './components/Checkout';
import OrderConfirmed from './components/OrderConfirmed';
import ProductDetail from './components/ProductDetail';
import SearchResults from './components/SearchResults';
import AdminLogin from './components/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import Dashboard from './components/admin/Dashboard';
import ManageProducts from './components/admin/ManageProducts';
import NewProduct from './components/admin/NewProduct';
import Customers from './components/admin/Customers';
import Suppliers from './components/admin/Suppliers';
import Orders from './components/admin/Orders';
import PoliticaPrivacidade from './components/pages/PoliticaPrivacidade';
import TermosDeUso from './components/pages/TermosDeUso';
import QuemSomos from './components/pages/QuemSomos';
import TrocaseDevolucoes from './components/pages/TrocaseDevolucoes';
import Register from './components/auth/Register';
import Login from './components/auth/Login';
import VerifyEmail from './components/auth/VerifyEmail';
import Account from './components/auth/Account';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import RequireCustomerAuth from './components/auth/RequireCustomerAuth';
import VisitTracker from './components/VisitTracker';

function App() {
  return (
    <CartProvider>
      <Router>
        <VisitTracker />
        <Routes>
          <Route path="/" element={<MainSite />} />
          <Route path="/departamento/:slug" element={<DepartmentPage />} />
          <Route path="/produto/:id" element={<ProductDetail />} />
          <Route path="/busca" element={<SearchResults />} />
          {/* Visitante pode calcular o frete; o login é exigido só na etapa de pagamento */}
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/pedido-confirmado" element={<OrderConfirmed />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/termos-de-uso" element={<TermosDeUso />} />
          <Route path="/quem-somos" element={<QuemSomos />} />
          <Route path="/trocas-e-devolucoes" element={<TrocaseDevolucoes />} />
          <Route path="/cadastro" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/minha-conta" element={<RequireCustomerAuth><Account /></RequireCustomerAuth>} />
          <Route path="/verificar-email/:token" element={<VerifyEmail />} />
          <Route path="/esqueci-minha-senha" element={<ForgotPassword />} />
          <Route path="/redefinir-senha/:token" element={<ResetPassword />} />
          <Route path="/tocadochefe" element={<AdminLogin />} />
          <Route path="/tocadochefe/painel" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="produtos" element={<ManageProducts />} />
            <Route path="novo-produto" element={<NewProduct />} />
            <Route path="clientes" element={<Customers />} />
            <Route path="fornecedores" element={<Suppliers />} />
            <Route path="pedidos" element={<Orders />} />
          </Route>
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
